import {watchLazyImageDom} from '@/view/lib/lazy'
import $ from 'jquery'
var manager = {
    controllers: {},
	functions: {},
    async active(dom,instanceId) {
		var group=new ControllerGroup(dom,instanceId)
		await group.active()
		return group
    },
    add(k, v) {
        if (v instanceof Function) {
            this.functions[k] = {
                created: v
            }
        } else {
            this.functions[k] = v
        }
    }
}

const defaultFns=["appLink"]

export class ControllerGroup{
	constructor(dom,instanceId){
		this.groupList=[]
		try {
			instanceId = instanceId||dom.getAttribute("instanceId")
			const reloveFnDom=fnDom => {
				let controllers=[]
				let funcChain=fnDom.getAttribute("module-function").replace(/[\r\n\t]/g,'')
				var fns = funcChain.split(';')
				fns=[...fns,...defaultFns]
				for (let i = 0; i < fns.length; i++) {
					let funcName = fns[i].match(/[\w.]+/)?fns[i].match(/[\w.]+/)[0]:null
					if (!funcName) {
						continue
					}
					if (!manager.functions[funcName]) {
						console.warn("函数" + funcName + "未定义")
						continue
					}
					let args
					let argMatch=fns[i].match(/\((.*)\)/)
					if(argMatch&&argMatch[1]){
						let argStr=argMatch[1].replace(/'/g,'"').replace(/^,/,"null,").replace(/,$/,",null").replace(/,,/g,",null,")
						try{
							args=JSON.parse(`[${argStr}]`)
						}catch(err){
							args=[]
						}
					}
					var controller = new Controller(instanceId,fnDom,funcName,args)
					controllers.push(controller)
				}
				this.groupList.push(controllers)
			}
			if(dom.children[0]&&$(dom.children[0]).hasClass('tab-module')){
				reloveFnDom(dom.children[0])
				$(dom.children[0]).find(":not(.tab-content [module-function])[module-function]").each(function(){
					reloveFnDom(this)
				})
			}else{
				Array.from(dom.querySelectorAll("[module-function]")).forEach(fnDom=>reloveFnDom(fnDom))
			}
		} catch (err) {
			console.warn("函数解析错误:",dom, err)
		}
	}
	active(){
		var promises=[]
		for(let i=0;i<this.groupList.length;i++){
			promises.push(this.run(this.groupList[i]))
		}
		return Promise.all(promises)
	}
	async run(controllers){
		for(let i=0;i<controllers.length;i++){
			await controllers[i].run()
		}
	}
	destroy(){
		for(let i=0;i<this.groupList.length;i++){
			let controllers=this.groupList[i]
			for(let j=0;j<controllers.length;j++){
				controllers[j].destroy()
			}
		}
		this.groupList=[]
	}
}

function transDom(dom){
	if(!dom)return
	manager.active(dom)
	Array.from(dom.querySelectorAll("[lazy-image]")).forEach(imgdom => {
        watchLazyImageDom(imgdom)
    })
	
}

export class Controller {
    constructor(instanceId,dom,funcName,args) {
		this.dom=dom
		this.funcName=funcName
		this.args=args
		this.fnCtx={
			...manager.functions[funcName],
			dom,
			instanceId,
			transDom
		}
	}
	async run(){
		try {
			if (manager.functions[this.funcName].created instanceof Function) {
				var res=manager.functions[this.funcName].created.apply(this.fnCtx,this.args)
				if (res instanceof Promise) { 
					return await res 
				}else{
					return res
				}
			}
		} catch (err) {
			console.warn("函数" + this.funcName + "执行错误:",this.dom, err)
		}
	}
    destroy() {
        if (manager.functions[this.funcName].destroyed instanceof Function) {
			manager.functions[this.funcName].destroyed.apply(this.fnCtx)
        }
    }
}

export default manager

// manager.functions.test
// manager.controllers[instanceId].dom
// this.manager.functions.test
// this.dom
// this.instanceId
// document.querySelectorAll(".J_module").forEach(dom=>manager.active(dom))
